import decode from 'jwt-decode';
import auth0 from 'auth0-js';
import Auth0Lock from 'auth0-lock';
import { EventEmitter } from 'events';
import { browserHistory } from 'react-router';
import Cookies from 'cookies-js';
import { isTokenExpired, getTokenExpirationDate } from './authHelpers';

const auth0LockOptions = {
    auth: {
        responseType: 'token id_token',
        audience: 'https://api.salespartner.customercare.rikstv.no',
        params: { scope: 'openid email profile' },
        sso: true,
    },
    autoclose: true,
};

class Auth0Service extends EventEmitter {
    constructor() {
        super();
    }
    
    _setupSession(authResult){
        this.setToken(authResult.accessToken);
        this.lock.getUserInfo(authResult.accessToken, (error, profile) => {
            if (!error) {
                this.setProfile(profile);
            }
        });
    }

    _doAuthentication(authResult) {
        this._setupSession(authResult)
        this.emit('ready_to_redirect', authResult.state);
    }

    _restoreOrStartSession(err, authResult) {
        if (authResult) {
           this._setupSession(authResult)
        }
        else {
            const query = window.location.hash.replace("#/", "");
            this.login(window.location.pathname + query);
        }
    }

    init({ clientID, domain, cookieDomain }) {
        this.clientID = clientID;
        this.cookieDomain = cookieDomain;
        this.lock = new Auth0Lock(clientID, domain, auth0LockOptions);
        this.lock.on('authenticated', this._doAuthentication.bind(this));
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);

        if (!this.loggedIn()) {
            this.lock.checkSession({}, (err, authResult) => this._restoreOrStartSession(err, authResult));
        }
    }

    login(nextUrl) {
        this.lock.show({
            auth: {
                ...auth0LockOptions.auth,
                params: {
                    state: nextUrl
                }
            }
        });
    }

    loggedIn() {
        const token = this.getToken();
        return !!token && !isTokenExpired(token);
    }

    setToken(accessToken) {
        localStorage.setItem('accessToken', accessToken);
    }

    getToken() {
        let token = localStorage.getItem('accessToken');
        return token;
    }

    setProfile(profile) {
        const json = JSON.stringify(profile);
        localStorage.setItem('profile', json);
        this.emit('profile_updated', profile);
    }

    getProfile() {
        let profile = localStorage.getItem('profile');
        return profile ? JSON.parse(profile) : {};
    }

    getPartnerId() {
        return this.getProfile()["https://salespartner.rikstv.no/partnerid"];
    }

    logout() {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('profile');
        this.emit('profile_updated', {});
        this.lock.logout();
    }
}

export default Auth0Service;